"use client";

import { Box } from "@/components/ui/box";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  XAxis,
  YAxis,
} from "recharts";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";

export interface DriverChartItem {
  status: string;
  total: number;
}

interface DriverChartProps {
  data: DriverChartItem[];
  config?: ChartConfig;
  barColor?: string; // default bar color
  height?: number;
}

export function DriverChart({
  data = [],
  config,
  barColor = "#1F9545",
  height = 180,
}: DriverChartProps) {
  // Jika config tidak dikirim, buat otomatis dari data
  const autoConfig: ChartConfig = config
    ? config
    : Object.fromEntries(
        data?.map((item) => [
          item.status,
          { label: item.status, color: barColor },
        ])
      );

  return (
    <ChartContainer config={autoConfig} className={`mx-auto w-full h-full`}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{
          left: 50,
          right: 24,
        }}
      >
        <CartesianGrid horizontal={false} />

        <YAxis
          dataKey="status"
          type="category"
          tickLine={false}
          tickMargin={10}
          axisLine={false}
          tickFormatter={(value) =>
            autoConfig[value as keyof typeof autoConfig]?.label as any
          }
        />

        <XAxis
          dataKey="total"
          type="number"
          tickLine={false}
          axisLine={false}
        />

        <ChartTooltip
          cursor={false}
          content={<ChartTooltipContent indicator="line" />}
        />

        <Bar
          dataKey="total"
          layout="vertical"
          radius={6}
          fill={barColor}
          barSize={22}
        >
          <LabelList
            dataKey="total"
            position="right"
            offset={8}
            fontSize={12}
            className="fill-foreground"
          />
        </Bar>
      </BarChart>
    </ChartContainer>
  );
}
